import { render, staticRenderFns } from "./OrganismIdcContactManagement.vue?vue&type=template&id=ef3bddaa&scoped=true&"
import script from "./OrganismIdcContactManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismIdcContactManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIdcContactManagement.vue?vue&type=style&index=0&id=ef3bddaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3bddaa",
  null
  
)

export default component.exports